module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei8.svg";